import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPresentationPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M21 14h-1V4h1a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2h1v10H3a1 1 0 0 0 0 2h8v1.15l-4.55 3A1 1 0 0 0 7 22a.94.94 0 0 0 .55-.17L11 19.55V21a1 1 0 0 0 2 0v-1.45l3.45 2.28A.94.94 0 0 0 17 22a1 1 0 0 0 .55-1.83l-4.55-3V16h8a1 1 0 0 0 0-2m-3 0H6V4h12Zm-8.39-1.74a1.73 1.73 0 0 0 1.76 0l3-1.74a1.76 1.76 0 0 0 0-3l-3-1.74a1.73 1.73 0 0 0-1.76 0 1.71 1.71 0 0 0-.87 1.52v3.48a1.71 1.71 0 0 0 .87 1.48m1.13-4.58L13 9l-2.28 1.32Z" />
  </svg>
);
export default SvgPresentationPlay;
